import { snapshotDiagnostics } from '../../utils/diagnosticsBuffer.js';

function readStorage(key) {
  try { return localStorage.getItem(key); } catch { return null; }
}

/**
 * Everything a report carries besides what the user typed. `pageContext` is
 * what App publishes through IssueReportProvider (view, session id, track,
 * laps, compare ids, admin/masquerade flags); the rest is read from the
 * browser here. No telemetry, no tokens — ids and environment only.
 */
export function buildIssueContext(pageContext = {}) {
  const nav = typeof navigator !== 'undefined' ? navigator : {};
  const win = typeof window !== 'undefined' ? window : {};
  return {
    ...pageContext,
    href: win.location?.href,
    userAgent: nav.userAgent,
    language: nav.language,
    online: nav.onLine,
    platform: nav.userAgentData?.platform || nav.platform,
    viewport: win.innerWidth ? { w: win.innerWidth, h: win.innerHeight, dpr: win.devicePixelRatio } : undefined,
    screen: win.screen ? { w: win.screen.width, h: win.screen.height } : undefined,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    theme: readStorage('trackapp:theme'),
    fontScale: readStorage('trackapp:fontScale'),
    reportedAt: new Date().toISOString(),
    recentErrors: snapshotDiagnostics(),
  };
}

export const ISSUE_CATEGORIES = [
  { key: 'bug',      label: 'Something is broken', short: 'Bug' },
  { key: 'feature',  label: 'Feature request',     short: 'Feature' },
  { key: 'question', label: 'Question',            short: 'Question' },
  { key: 'other',    label: 'Other',               short: 'Other' },
];

export const ISSUE_STATUSES = [
  { key: 'open',        label: 'Open' },
  { key: 'in_progress', label: 'In progress' },
  { key: 'resolved',    label: 'Resolved' },
  { key: 'closed',      label: 'Closed' },
];

export function categoryLabel(key, { short = false } = {}) {
  const c = ISSUE_CATEGORIES.find(x => x.key === key);
  return (short ? c?.short : c?.label) || key;
}

export function statusLabel(key) {
  return ISSUE_STATUSES.find(s => s.key === key)?.label || key;
}
